import React from "react";
import Alert from '@mui/material/Alert';
import useDebugInformation from "../../../../../../../../../hooks/useDebugInformation";
import Box from "@mui/material/Box";
import { useAppSelector } from "@store/hooks";

type Props = {
}
const OptionsNotification: React.FC<Props> = () => {
    const problemComboTrade = useAppSelector(({ ui }) => ui.ProblemComboTrade)
    const requiredOptionsValid = useAppSelector(({ state }) => state.RequiredOptionsValid)

    useDebugInformation("OptionsNotification", { problemComboTrade, requiredOptionsValid })
    return (
        <Box sx={(theme) => ({
            width: '100%',
            userSelect: "none",
            '& > * + *': {
                marginTop: theme.spacing(2),
            },
            '& .MuiAlert-root': { justifyContent: "center" },
        })}>
            {problemComboTrade &&
                <Alert variant="outlined"
                    severity={requiredOptionsValid ? "success" : "error"}>
                    {requiredOptionsValid ? `Required questions completed` : `Required questions missing!!`}
                </Alert>}
        </Box>
    )
}

export default React.memo(OptionsNotification)